import { useEffect } from 'react';

import { MutableRefObject } from 'react';
import { MapInfoWindowProps } from '../ui/MapInfoWindow/MapInfoWindow';

import { MAP_INFO_WINDOW_ID } from '../constants';

const SUBSTRING_POPPER_CLASS = 'popper';

export const useDocumentListenerToCloseInfoWindow = (
  infoWindowRef: MutableRefObject<any>,
  onClose: MapInfoWindowProps['onClose']
) => {
  useEffect(() => {
    const handleDocumentClick = (event: MouseEvent) => {
      let targetElement = event.target;
      const popupElement = document.getElementById(MAP_INFO_WINDOW_ID);
  
      do {
        // @ts-ignore
        if (targetElement && (targetElement === popupElement || `${targetElement.className}`.toLowerCase().includes(SUBSTRING_POPPER_CLASS))) {
          return;
        }
  
        // @ts-ignore
        targetElement = (targetElement || {}).parentNode;
      } while (targetElement);
    
      if(onClose) {
        onClose();
      }

      if (infoWindowRef.current) {
        infoWindowRef.current.hide();
      }
    }

    // @ts-ignore
    window.document.addEventListener('click', handleDocumentClick);

    return () => {
      // @ts-ignore
      window.document.removeEventListener('click', handleDocumentClick);
    };
    // eslint-disable-next-line
  }, []);
};
